import { Outlet } from 'react-router-dom';
import { Link, useResolvedPath, useMatch } from 'react-router-dom';

function TabDivider() {
  return (
    <div className="h-full flex mx-2">
      <div className="w-px bg-gray-200 h-4/5"></div>
    </div>
  );
}

type MyWorkTabProps = {
  text: string;
  to: string;
  className?: string;
};

function MyWorkTab({ text, to, className }: MyWorkTabProps) {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: false });

  return (
    <Link className="hover:text-primary text-lg px-3" to={to}>
      <div
        className={`pb-2 ${
          match ? 'font-bold text-primary border-b-4 border-primary' : ''
        } ${className ? className : ''}`}
      >
        {text}
      </div>
    </Link>
  );
}

export default function MyWorkRoutes() {
  return (
    <div className="w-full flex flex-col px-3">
      <div className="flex flex-row w-full pt-6 mb-8 border-b">
        <MyWorkTab text="Activations" to="distributions" />
        <TabDivider />
        <MyWorkTab text="Orders" to="orders" />
        <TabDivider />
        <MyWorkTab text="Saved Audiences" to="audiences" />
        <TabDivider />
        <MyWorkTab text="Uploaded Files" to="files" />
        <TabDivider />
        <MyWorkTab text="Ask Addy" to="ask-addy" />
      </div>
      <div className="flex flex-grow h-full w-full overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
